import { render, staticRenderFns } from "./SingleProject.vue?vue&type=template&id=324fbea2&scoped=true&"
import script from "./SingleProject.vue?vue&type=script&lang=js&"
export * from "./SingleProject.vue?vue&type=script&lang=js&"
import style0 from "./SingleProject.vue?vue&type=style&index=0&id=324fbea2&prod&scoped=true&lang=css&"
import style1 from "./SingleProject.vue?vue&type=style&index=1&id=324fbea2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324fbea2",
  null
  
)

export default component.exports